import { replaceHtmlTagsToSpecialSymbols } from '@gem/utils';

import { PayloadType } from 'APP/model/message/messageModel.types';

export default (payload) => {
  if (payload.payloadType !== PayloadType.RichText) {
    return payload;
  }

  return {
    ...payload,
    text: replaceHtmlTagsToSpecialSymbols(payload.text),
  };
};
